module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABDBAMAAACYZb3pAAAAFVBMVEXVKx7///8AOaZUNHFkh8nVKx7///90yNRsAAAAAnRSTlPU1BJ52+4AAAA3SURBVEjH7csxAQAgEMSws4AFLGABC1jAv4TX0PmaPVlYPmaxWErLxbIxi8VSWg6Wh1ksltLCDf2spTBQVKLHAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/ru.png
// module id = Vt2w
// module chunks = 0